import axios from '../services/axios'
import { BASE_URL } from './environment'

/**
 * Before the app starts: the site sends people here with ?handoff=<one-time code> (Play games, students signing
 * in), never the sign-in token itself, which stayed in the browser history and server logs and reached anything the
 * page loaded. The code is swapped for the token (API auth/handoff, works once, for 2 minutes) and removed from the
 * address. Any token saved from an earlier person on this device goes first, so a code that fails never leaves
 * someone else signed in.
 */
export async function exchangeHandoff() {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('handoff')
    if (!code) {
        return
    }
    params.delete('handoff')
    const rest = params.toString()
    window.history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash)
    localStorage.removeItem('authToken')
    try {
        const response = await fetch(BASE_URL + 'auth/handoff', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ code }),
        })
        const json = await response.json()
        if (json && json.body && json.body.token) {
            localStorage.setItem('authToken', json.body.token)
        }
    } catch (e) {
        // No token: getAuthToken sends them back to sign in.
    }
}

export function getAuthToken() {
    let location = window.location
    // ?authToken= is what the site sent before the handoff code (kept while both versions are live).
    const legacy = new URLSearchParams(location.search).get('authToken')
    if (legacy || localStorage.getItem('authToken') || process.env.NODE_ENV === 'development') {
        const setToken = legacy || localStorage.getItem('authToken')
        axios.defaults.headers.common['Authorization'] = `Bearer ${setToken}`
        localStorage.setItem('authToken', setToken)
        if (legacy) {
            window.history.replaceState(null, null, window.location.pathname)
        }
        return false
    } else {
        window.location.replace(process.env.REACT_APP_PAGE_BACKEND)
        return true
    }
}
